import request from '@/plugin/axios'

export function getMemberPageList(query) {
    return request({
        url: '/merbersysapp/memberPageList',
        method: 'post',
        params: query
    })
}

export function getMemberPageListLog(query) {
    return request({
        url: '/merbersysapp/memberLogPageList',
        method: 'post',
        params: query
    })
}


export function getShMemberPageList(query) {
    return request({
        url: '/merbersysapp/shmemberPageList',
        method: 'post',
        params: query
    })
}

export function getDlPageList(query) {
    return request({
        url: '/merbersysapp/dlPageList',
        method: 'post',
        params: query
    })
}
export function getAddressPageList(query) {
    return request({
        url: '/merbersysapp/addressPageList',
        method: 'post',
        params: query
    })
}

export function getCommentPageList(query) {
    return request({
        url: '/merbersysapp/commentPageList',
        method: 'post',
        params: query
    })
}


export function delMembergl(data) {
    return request({
        url: '/merbersysapp/delMembergl',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delMemberglSh(data) {
    return request({
        url: '/merbersysapp/delMemberglSh',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delAddress(data) {
    return request({
        url: '/merbersysapp/delAddress',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delComment(data) {
    return request({
        url: '/merbersysapp/delComment',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function updateComment(data) {
    return request({
        url: '/merbersysapp/updateComment',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '操作成功',
                type: 'success'
            }
        }
    })
}

export function getAgentXtid(data) {
    return request({
        url: '/moblieapp/getAgentXtid',
        method: 'post',
        data: data,
        loading: {
            type: 'nprogress',
            interval: 500
        }
    })
}


export function saveMemberCard(data) {
    return request({
        url: '/merbersysapp/MemberSaveCard',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}

export function saveJzMemberCard(data) {
    return request({
        url: '/merbersysapp/JzMemberSaveCard',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}

export function ExtensImgSave(data) {
    return request({
        url: '/merbersysapp/ExtensImgSave',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}

export function delMemberprice(data) {
    return request({
        url: '/merbersysapp/delMemberprice',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delJzMemberprice(data) {
    return request({
        url: '/merbersysapp/delJzMemberprice',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function updateExtensimg(data) {
    return request({
        url: '/merbersysapp/updateExtensimg',
        method: 'post',
        data: data
    })
}

export function delExtensimg(data) {
    return request({
        url: '/merbersysapp/delExtensimg',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delMemberglBath(ids) {
    return request({
        url: '/merbersysapp/delMemberglBath',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delMemberglBathSh(ids) {
    return request({
        url: '/merbersysapp/delMemberglBathSh',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function qrMemberglBath(query) {
    console.info("&&&&&&&",query);
    return request({
        url: '/merbersysapp/qrMemberglBath',
        method: 'delete',
        params: query,
        success: {
            type: 'message',
            options: {
                message: '操作成功',
                type: 'success'
            }
        }
    })
}





export function delAddressBath(ids) {
    return request({
        url: '/merbersysapp/delAddressBath',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}


export function delCommentBath(ids) {
    return request({
        url: '/merbersysapp/delCommentBath',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}


export function listMemberCard(query) {
    return request({
        url: '/merbersysapp/listMemberCard',
        method: 'post',
        params: query
    })
}

export function listJzMemberCard(query) {
    return request({
        url: '/merbersysapp/listJzMemberCard',
        method: 'post',
        params: query
    })
}


export function listMemberUser(query) {
    return request({
        url: '/merbersysapp/listMemberUser',
        method: 'post',
        params: query
    })
}

export function listMemberShUser(query) {
    return request({
        url: '/merbersysapp/listMemberShUser',
        method: 'post',
        params: query
    })
}


export function listExtensImg(query) {
    return request({
        url: '/merbersysapp/listExtensImg',
        method: 'post',
        params: query
    })
}



export function delMemberpriceBath(ids) {
    return request({
        url: '/merbersysapp/delMemberpriceBath',
        method: 'delete',
        data: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delJzMemberpriceBath(ids) {
    return request({
        url: '/merbersysapp/delJzMemberpriceBath',
        method: 'delete',
        data: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}


export function delExtensimgBath(ids) {
    return request({
        url: '/merbersysapp/delExtensimgBath',
        method: 'delete',
        data: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}
